import { createFileRoute, notFound } from '@tanstack/react-router'
import { allPages } from 'content-collections'
import { Markdown } from '@/components/ui/markdown'

export const Route = createFileRoute('/_public/terms')({
  staticData: {
    title: 'Terms of Service — PhoneSalad',
    description: 'Read the terms and conditions for using PhoneSalad international calling services, including billing, usage policies, and account guidelines.',
    sitemap: { priority: '0.3', changefreq: 'yearly' },
  },
  loader: () => {
    const page = allPages.find((p) => p.slug === 'terms-of-service')
    if (!page) throw notFound()
    return page
  },
  component: TermsPage,
})

function TermsPage() {
  const page = Route.useLoaderData()

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 pt-20">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg dark:prose-invert max-w-none">
            <Markdown content={page.content} />
          </div>
        </div>
      </div>
    </div>
  )
}
